export enum CourseOutlineTaskTypeEnum {
  Pdf = 'pdf',
  Video = 'video',
  Exercise = 'exercise',
}
